(function() {
  'use strict';

  angular.module('app')
    .controller('PriceChangeCtrl', PriceChangeCtrl);

  /** @ngInject */
  function PriceChangeCtrl($uibModalInstance, $scope, header, data) {
    $scope.header = header;
    $scope.increaseDecrease = '';
    $scope.data = data;
    $scope.auctionDate = data.auctionDate;
    // if the price increased set the text accordingly
    if (data.price < 0) {
      $scope.increaseDecrease = 'decreased';
    } else {
      $scope.increaseDecrease = 'increased';
    }

    $scope.price = Math.abs(data.price);

    $scope.dateFormat = 'MM/dd/yyyy';

    $scope.fOpenStart = function(item) {
      item.opened = true;
    };

    $scope.updatePrice = function() {
      $uibModalInstance.close({
        date: $scope.auctionDate
      });
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss(null);
    };
  }
})();
